import ExplorerCard from 'ui-component/cards/ExplorerCard';
import MemberHomePage from './Components/MemberHomePage';
const MemberHome = () => {
    return (
        <ExplorerCard>
            <MemberHomePage />
        </ExplorerCard>
    );
};

export default MemberHome;
